import React from "react";

interface ClampProps {
  lines?: number;
  className?: string;
  children: React.ReactNode;
}

export function Clamp({lines = 12, className, children}: ClampProps) {
  return (
    <div
      className={className}
      style={{
        display: "-webkit-box",
        WebkitBoxOrient: "vertical" as any,
        overflow: "hidden",
        WebkitLineClamp: lines,
        lineClamp: lines,
        wordBreak: "break-word",
      }}
    >
      {children}
    </div>
  );
}
